import apiService from "../api";

export const getMyVaccination = (page: any, size: number) => {
  const url = `/vaccine/myvaccinations/?page=${page}&size=${size}`;

  return apiService(url, "GET", null, true);
};

export const getMyVaccinationDetails = (vid: string) => {
  const url = `/vaccine/myvaccinations/${vid}/`;

  return apiService(url, "GET", null, true);
};

export const downloadVaccination = (v_id: string, is_bulk: boolean = false) => {
  const url = "/vaccine/vaccinations/downloads/payment/";
  const payload = is_bulk ? { is_bulk } : { vaccination_vid: v_id, is_bulk };

  return apiService(url, "POST", payload, true);
};
